import styled from 'styled-components';

const BottomWrap = styled.div`
  padding: 10px 30px;
`;

const Bottom = () => {
  return (
    <BottomWrap>
      [스마트피싱보호] 앱을 이용하시면, 부모님이 보이스피싱 통화시 알림, 보이스피싱 의심전화 수신
      알림, 모바일 뱅킹 앱 실행시 알림, 단계별 피싱위험 알림 등 각종 피싱사기로부터 안전하게 보호
      받으실 수 있습니다.
    </BottomWrap>
  );
};

export default Bottom;
